import * as React from "react";
import { Button } from 'primereact/button';
import {InputTextarea} from "primereact/inputtextarea";

export type ExperienceItem = {
    dateTo: string;
    dateFrom: string;
    comment: string;
}
interface WorkExperienceItemProps {
    item: ExperienceItem;
    index: number;
    updateValue: (newValue: ExperienceItem, index: number) => void;
    deleteValue: (index: number) => void;
    // Говорит о том что поле использует i18n
    isHaveI18n: boolean;
    // Говорит о том что есть конкретное поле для i18n (его может и не быть, если выбран только русский перевод, а поле является i18n)
    i18nPropertyName?: string;
}

const getI18nCommentFields = (isHaveI18n, i18nPropertyName): {name: string; placeholder: string}[] => {
    const commentFields = [];
    if(isHaveI18n) {
        commentFields.push({name: 'comment_ru', placeholder: 'Русский текст'});
        if(i18nPropertyName) {
            commentFields.push({name: i18nPropertyName, placeholder: 'Английский текст'});
        }
    } else {
        commentFields.push({name: 'comment', placeholder: 'Русский текст'});
    }

    return commentFields
}

const WorkExperienceItem = ({item, index, updateValue, deleteValue, isHaveI18n, i18nPropertyName}: WorkExperienceItemProps) => {

    /**
     * Обновляет элемент по его индексу
     * @param e
     */
    const handleChange = (e) => {
        const newItem = {
            ...item,
            [e.target.name]: e.target.value
        };
        updateValue(newItem, index);
    }

    const commentFields = getI18nCommentFields(isHaveI18n, i18nPropertyName);
    return <div className='position-relative'>

        <div className='panel panel-default p-2'>
            <div className='row'>
                <span className='col-xs-12'>
                    Начало и окончание работы
                </span>
            </div>
            <div className='row mb-1'>
                <div className='col-xs-12'>
                    <input
                        name='dateTo'
                        type='date'
                        onChange={handleChange}
                        value={item.dateTo}
                        className='col-xs-2 mr-1'
                    />
                    <input
                        name='dateFrom'
                        type='date'
                        onChange={handleChange}
                        value={item.dateFrom}
                        className='col-xs-2 mr-1'
                    />
                </div>
            </div>
            <div className='row'>
                {
                    commentFields.map(({name, placeholder}) => (
                        <div className={`col-xs-${12 / commentFields.length}`}>
                            <textarea
                                name={name}
                                onChange={handleChange}
                                value={item[name]}
                                placeholder={placeholder}
                                className='form-control col-xs-12'
                            />
                        </div>
                    ))
                }
            </div>
        </div>

        { /* @ts-ignore */ }
        <Button
            icon="pi pi-times"
            className="p-button-rounded p-button-text position-absolute top-0 right-0"
            onClick={() => deleteValue(index)}
            type="button"
            style={{position: 'absolute', top: 0, right: 0}}
        />
    </div>
}

export default WorkExperienceItem;